module.exports = "/_next/static/images/icon-arrow-prev-653889e6de0476afa8e245414b4ab327.png";